export const DATE_FORMATS = {
  messages: 'MMM D',
  full: 'MM/DD/YYYY',
  api: 'YYYY-MM-DD',
  fanMessage: 'DD.MM.YYYY',
  iso: 'YYYY-MM-DDTHH:mm:ssZZ',
  dayMonth: 'MMMM D',
};
